import styled from "styled-components";

export const StyledInvoiceWrapper = styled.div`
  display: inline-grid;
  grid-template-rows: 55px;
  button {
    height: 100%;
  }
`;

export const StyledInvoiceAttrInputWrapper = styled.div`
  position: relative;
  label {
    color: rgba(0, 0, 0, 0.54);
    font-size: 14px;
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  }
  input {
    padding: 5px 0 7px;
    color: #000;
    border: none;
    background-color: transparent;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    &:hover {
      border-bottom: 1px solid rgba(0, 0, 0, 1);
      box-shadow: 0 1px 0 0 rgba(0,0,0,1);
    }
    &:focus {
      border-bottom: 1px solid #3f51b5;
    }

    &::-webkit-input-placeholder {
      opacity: 0.35;
    }
    &:-moz-placeholder {
      opacity: 0.35;
    }
    &::-moz-placeholder {
      opacity: 0.35;
    }
    &:-ms-input-placeholder {
      opacity: 0.35;
    }
  }
`;